import { Stack, Box, Typography, Link } from "@mui/material";
import { icons } from "assets/AssetHelper";
import { useTranslation } from "react-i18next";

export default function VoucherInfo({ details }) {
  const { t } = useTranslation();
  const recipient = details?.recipient_information;

  // Format phone number for WhatsApp link
  const whatsappUrl = `https://wa.me/${
    recipient?.country_code
  }${recipient?.phone_number?.replace(/^0+/, "")}`;

  const voucherInfo = {
    [t("orders.recipient_name")]: recipient?.name || "N/A",
    [t("orders.phone_number")]: (
      <Link
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ textDecoration: "none", color: "inherit" }}
      >
        +({recipient?.country_code}) {recipient?.phone_number}
      </Link>
    ),
    [t("orders.email")]: (
      <Link
        href={recipient?.email ? `mailto:${recipient?.email}` : ""}
        sx={{ textDecoration: "none", color: "primary.main" }}
        style={{ pointerEvents: recipient?.email ? "auto" : "none" }}
      >
        {recipient?.email || "N/A"}
      </Link>
    ),
  };

  const cardStyle = {
    // width: "47%",
    backgroundColor: "white",
    p: 3,
    gap: 3,
    boxSizing: "border-box",
    borderRadius: "8px",
  };

  return (
    <Stack sx={cardStyle}>
      {/* ----------- CARD HEADER ----------- */}
      <Stack direction="row" alignItems="center" gap={2}>
        <Box component="img" width="46px" src={icons.userInfo} />
        <Typography fontWeight="500" fontSize={{ xs: "18px", sm: "24px" }}>
          Voucher Info
        </Typography>
      </Stack>

      {/* ----------- CARD INFO ----------- */}
      <Stack gap={2} width={{ xs: "100%", md: "47%" }}>
        {Object.entries(voucherInfo).map(([key, value], i) => (
          <Stack key={i} direction="row" justifyContent="space-between">
            <Typography sx={{ width: "30%", color: "#969696", fontSize: { xs: "13px", sm: "16px" } }}>
              {key}
            </Typography>
            <Typography component="div" sx={{ width: "70%", fontSize: { xs: "14px", sm: "16px" } }}>
              {value}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
